import {combineReducers} from "redux";
import {BusquedaSolicitudReducer} from "./modules/busquedaSolicitud/reducers";
import {CargaDocumentalReducer} from "./modules/cargaDocumental/reducers";
import {SeguridadReducer} from "./modules/seguridad/reducers";
import {consultarCodigoGTMReducer} from "./modules/consultarCodigoGTM/reducers";

export const RecepcionDocumentalInternetReducer = combineReducers({
  seguridad: SeguridadReducer,
  solicitudes: BusquedaSolicitudReducer,
  carga: CargaDocumentalReducer,
  GTM: consultarCodigoGTMReducer
});
